var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicstick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_1609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17.5L17.5 5L15 2.5L2.5 15L5 17.5Z",
    stroke: "#072F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5L15 7.5",
    stroke: "#072F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 2.5C7.49992 2.94203 7.67551 3.36595 7.98807 3.67851C8.30063 3.99107 8.72456 4.16667 9.16659 4.16667C8.72456 4.16667 8.30063 4.34226 7.98807 4.65482C7.67551 4.96738 7.49992 5.39131 7.49992 5.83333C7.49992 5.39131 7.32432 4.96738 7.01176 4.65482C6.6992 4.34226 6.27528 4.16667 5.83325 4.16667C6.27528 4.16667 6.6992 3.99107 7.01176 3.67851C7.32432 3.36595 7.49992 2.94203 7.49992 2.5Z",
    stroke: "#072F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 10.833C15.8334 11.275 16.009 11.699 16.3216 12.0115C16.6341 12.3241 17.0581 12.4997 17.5001 12.4997C17.0581 12.4997 16.6341 12.6753 16.3216 12.9878C16.009 13.3004 15.8334 13.7243 15.8334 14.1663C15.8334 13.7243 15.6578 13.3004 15.3453 12.9878C15.0327 12.6753 14.6088 12.4997 14.1667 12.4997C14.6088 12.4997 15.0327 12.3241 15.3453 12.0115C15.6578 11.699 15.8334 11.275 15.8334 10.833Z",
    stroke: "#072F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_1609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicstick);
export default __webpack_public_path__ + "static/media/magicstick.79716f39.svg";
export { ForwardRef as ReactComponent };